import { render, staticRenderFns } from "./list_products.html?vue&type=template&id=30a6db20&scoped=true&"
import script from "./list_products.ts?vue&type=script&lang=js&"
export * from "./list_products.ts?vue&type=script&lang=js&"
import style0 from "./list_products.scss?vue&type=style&index=0&id=30a6db20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a6db20",
  null
  
)

export default component.exports